import { render, staticRenderFns } from "./VideoFormatPicker.vue?vue&type=template&id=08488907&scoped=true"
import script from "./VideoFormatPicker.vue?vue&type=script&lang=js"
export * from "./VideoFormatPicker.vue?vue&type=script&lang=js"
import style0 from "./VideoFormatPicker.vue?vue&type=style&index=0&id=08488907&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08488907",
  null
  
)

export default component.exports